import Controller from '@ember/controller';
import RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import { cached, tracked } from '@glimmer/tracking';
import currency from 'currency.js';
import { TransactionsEditEnterRouteModel } from 'donor-elf-web/routes/funds/fund/transactions/edit/enter';
import TransactionsService from 'donor-elf-web/services/transactions-service';

export default class TransactionsEditEnterController extends Controller {
  @service declare router: RouterService;
  @service declare transactionsService: TransactionsService;

  model!: TransactionsEditEnterRouteModel;
  @tracked hasErrors = false;

  get lineItemInfos() {
    return this.transactionsService.lineItemInfos;
  }

  get transTypes() {
    return this.model.transTypes;
  }

  @cached
  get sortedTransTypes() {
    return this.transTypes.sort((a, b) => {
      if (a === b) {
        return 0;
      }
      if (a > b) {
        return 1;
      }
      if (b > a) {
        return -1;
      }
      return 0;
    });
  }

  get lineItemChangesets() {
    return this.lineItemInfos.map((x) => x.changeset);
  }

  @cached
  get isEditingPersistedTransaction() {
    return (
      this.lineItemInfos.length === 1 && !this.lineItemInfos[0].model.isNew
    );
  }

  get lineItemsTotalAmount() {
    return this.lineItemChangesets.reduce((prevVal, changeset) => {
      return currency(prevVal).add(Number(changeset.get('amount') || 0));
    }, 0);
  }

  templateWillDestroy = () => {
    this.hasErrors = false;
  };

  save = async () => {
    let valid = true;
    for (let changeset of this.lineItemChangesets) {
      await changeset.validate();
      if (changeset.get('isValid') === false) {
        valid = false;
      }
    }
    this.hasErrors = !valid;
    if (valid) {
      this.router.transitionTo('funds.fund.transactions.edit.save');
    }
  };

  cancel = () => {
    window.history.back();
  };

  delete = (changeset: any) => {
    let info = this.lineItemInfos.find((item) => {
      return item.changeset === changeset;
    })!;
    let persistedTransaction = !info.model.isNew;
    if (persistedTransaction) {
      this.router.transitionTo('funds.fund.transactions.delete', info.model.id);
    } else {
      this.transactionsService.lineItemInfos = this.lineItemInfos.filter(
        (x) => x !== info,
      );
    }
  };

  addLineItemRecord = () => {
    let info = this.transactionsService.addLineItemInfo();
    this.model.focusOn = {
      changeset: info.changeset,
      fieldName: 'transDate',
    };
  };
}
